import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@material-ui/core';
import { CheckCircle, PlayCircleFilled, Error, DeleteOutline } from '@material-ui/icons';
import VariantService from '../../../../services/VariantService/VariantService';
import DeployDialog from './DeployDialog';
import Errors from './Errors';
import './Test.css';
/**
 * @Description This function returns Test section.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Test ({ state, setState }) {
    const { t } = useTranslation();
    const label = 'CONTENT.VARIANTS.';
    const [open, setOpen] = useState(true);
    const [error, setError] = useState();
    const handleRun = async (item) => {
        item.environment_target = 'local';
        const res = await VariantService.variantTestRun(item);
        if (res?.status) {
            item.test = 1;
        } else {
            item.test = 2;
            setError({ res, item });
        }
        setState({ ...state });
        return res?.status ? 1 : 2;
    };
    const handleDelete = (index) => {
        state.variant.first.splice(index, 1);
        localStorage.setItem('variant_state', JSON.stringify(state));
        setState({ ...state });
    };
    return (
        <div className="vtest">
            {error ? <Errors error={error} setError={setError} state={state} setState={setState} />:
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{t(label + 'VARIANT')}</th>
                            <th>{t(label + 'ACTIONS')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {state.variant.first.map((item, itemI) =>
                            <Row key={itemI} item={item} itemI={itemI} onRun={handleRun} onDelete={handleDelete} />
                        )}
                    </tbody>
                </table>
            }
            {(!window.location.pathname.includes('autom-store') && open) && <DeployDialog setOpen={setOpen} />}
        </div>
    );
}
function Row ({ item, itemI, onRun, onDelete }) {
    const [state, setSuccess] = useState(item.test ? item.test : 0);
    const handleRun = async () => { setSuccess(await onRun(item)); };
    useEffect(() => { setSuccess(item.test ? item.test : 0); }, [item]);
    return (
        <tr className="vvariable">
            <td>{itemI + 1}.</td>
            <td>{item.name}</td>
            <td>
                <IconButton size="small" onClick={handleRun}>
                    {state === 0 ?
                        <PlayCircleFilled color="action" /> :
                        state === 1 ?
                            <CheckCircle style={{ color: '#02B554' }} /> :
                            <Error style={{ color: '#D75E5E' }} />
                    }
                </IconButton>
                <IconButton size="small" onClick={() => onDelete(itemI)}>
                    <DeleteOutline fontSize="small" />
                </IconButton>
            </td>
        </tr>
    );
}
export default Test;